import {
  IIndividualFormValues,
  IInfoBaseFormValues,
  ILegalFormValues
} from '@/types/infoStep'

interface IInputField {
  name: keyof (IInfoBaseFormValues & ILegalFormValues & IIndividualFormValues)
  id: string
  labelContent: string
  type: string
  postFix?: string
  datePicker?: boolean
  placeholder?: string
}

export const legalUserFields: IInputField[] = [
  {
    name: 'companyNationalId',
    id: 'companyNationalId',
    labelContent: 'شناسه ملی شرکت',
    placeholder: 'کد ملی شرکت وارد کنید',
    type: 'tel'
  },
  {
    name: 'companyEconomicCode',
    id: 'companyEconomicCode',
    labelContent: 'کد اقتصادی شرکت',
    placeholder: 'کد اقتصادی شرکت خود را وارد کنید',
    type: 'tel'
  },
  {
    name: 'registrationNumber',
    id: 'registrationNumber',
    labelContent: 'شماره ثبت',
    placeholder: 'شماره ثبت شرکت را وارد کنید',
    type: 'tel'
  },
  {
    name: 'companyName',
    id: 'companyName',
    labelContent: 'نام شرکت',
    placeholder: 'نام شرکت خود را وارد کنید',
    type: 'text'
  },
  {
    name: 'storeBrandName',
    id: 'storeBrandName',
    labelContent: 'نام فروشگاه/برند',
    placeholder: 'نام فروشگاه/برند خود را وارد کنید',
    type: 'text'
  },
  {
    name: 'website',
    id: 'website',
    labelContent: 'آدرس وبسایت',
    type: 'text',
    postFix: '//:https'
  },
  {
    name: 'signatoryOwners',
    id: 'signatoryOwners',
    labelContent: 'نام صاحبان امضا',
    placeholder: 'نام صاحبان امضا را وارد کنید',
    type: 'text'
  }
]

export const individualUserFields: IInputField[] = [
  {
    name: 'licenseCategory',
    id: 'licenseCategory',
    labelContent: 'رسته جواز کسب',
    placeholder: 'رسته جواز کسب را وارد کنید',
    type: 'text'
  },
  {
    name: 'businessLicenseNumber',
    id: 'businessLicenseNumber',
    labelContent: 'شماره جواز کسب',
    placeholder: 'شماره جواز کسب را وارد کنید',
    type: 'tel'
  },
  {
    name: 'isicCode',
    id: 'isicCode',
    labelContent: 'کد آیسیک',
    placeholder: 'کد آیسیک را وارد کنید',
    type: 'tel'
  },
  {
    name: 'licenseExpirationDate',
    id: 'licenseExpirationDate',
    labelContent: 'تاریخ انقضاء جواز کسب',
    placeholder: 'شماره جواز کسب را وارد کنید',
    type: 'text',
    datePicker: true
  },
  {
    name: 'storeName',
    id: 'storeName',
    labelContent: 'نام فروشگاه',
    placeholder: 'نام فروشگاه خود را وارد کنید',
    type: 'text'
  },
  {
    name: 'website',
    id: 'website',
    labelContent: 'آدرس وبسایت فروشگاه',
    type: 'text',
    postFix: '//:https'
  }
]

export const userInfoFields: IInputField[] = [
  {
    name: 'firstName',
    id: 'firstName',
    labelContent: 'نام',
    placeholder: 'نام خود را وارد کنید',
    type: 'text'
  },
  {
    name: 'lastName',
    id: 'lastName',
    labelContent: 'نام خانوادگی',
    placeholder: 'نام خانوادگی خود را وارد کنید',
    type: 'text'
  },
  {
    name: 'nationalId',
    id: 'nationalId',
    labelContent: 'کد ملی',
    placeholder: 'کد ملی خود را وارد کنید',
    type: 'tel'
  },
  {
    name: 'email',
    id: 'email',
    labelContent: 'ایمیل',
    placeholder: 'ایمیل خود را وارد کنید',
    type: 'email'
  },
  {
    name: 'username',
    id: 'username',
    labelContent: 'نام کاربری',
    placeholder: 'نام کاربری خود را وارد کنید',
    type: 'text'
  },
  {
    name: 'shebaNumber',
    id: 'shebaNumber',
    labelContent: 'شماره شبا',
    placeholder: 'شماره شبا خود را وارد کنید',
    type: 'tel',
    postFix: 'IR'
  }
]
